/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function hightlightText(_ref) {
  var queryText = _ref.queryText,
    text = _ref.text,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'contains' : _ref$mode;
  var regex = mode === 'contains' ? new RegExp(queryText, 'gi') : new RegExp("^".concat(queryText), 'gi');
  var matchText = [];
  var searchQueryLen = queryText.length;
  var localMatch;
  var previousLocalMatch;
  while ((localMatch = regex.exec(text)) !== null) {
    var index = localMatch.index;
    var previousSegmentIndex = previousLocalMatch ? previousLocalMatch.index + searchQueryLen : 0;
    matchText.push(text.slice(previousSegmentIndex, index));
    matchText.push({
      match: text.slice(localMatch.index, localMatch.index + searchQueryLen)
    });
    previousLocalMatch = localMatch;
  }
  matchText.push(text.slice(previousLocalMatch.index + searchQueryLen));
  matchText = matchText.filter(function (match) {
    return match;
  });
  return matchText;
}
var _default = hightlightText;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/hightlightText.js
// module id = 675
// module chunks = 0